import React from "react";
import PropTypes from "prop-types";
import { User } from "phosphor-react";
import PhoneInput from "react-phone-number-input";
import InputField from "components/Input";
import "react-phone-number-input/style.css";
import "./index.scss";

const ContactDetails = ({
  formik,
  setPhoneNumber,
  phoneNumber,
  phoneNumberError,
}) => {
  return (
    <div className="payment-contact-details">
      <h2>Contact Details</h2>
      <div className="icon-wrapper">
        <User size={32} color="#070C1E" />
      </div>
      <InputField
        id="name"
        placeholder="Full name"
        label="Full name"
        value={formik.values.name}
        onChange={formik.handleChange}
        onBlur={formik.handleBlur}
        error={formik.errors.name}
      />
      <InputField
        id="email"
        placeholder="Email"
        label="Email Address"
        value={formik.values.email}
        onChange={formik.handleChange}
        onBlur={formik.handleBlur}
        error={formik.errors.email}
      />
      <div className="input-field">
        <PhoneInput
          placeholder="Enter phone number"
          defaultCountry="AU"
          international
          className={`input ${
            phoneNumberError && phoneNumber === "" ? "-errors" : ""
          }`}
          value={phoneNumber}
          onChange={setPhoneNumber}
          errors={phoneNumberError}
        />
        <label className="label">Mobile Number</label>
      </div>
    </div>
  );
};

ContactDetails.defaultProps = {
  formik: {},
  setPhoneNumber: () => {},
  phoneNumber: "",
  phoneNumberError: "",
};

ContactDetails.propTypes = {
  formik: PropTypes.shape({
    getFieldProps: PropTypes.func.isRequired,
    handleChange: PropTypes.func.isRequired,
    handleBlur: PropTypes.func.isRequired,
    values: PropTypes.shape({
      name: PropTypes.string,
      email: PropTypes.string,
    }),
    errors: PropTypes.shape({
      name: PropTypes.string,
      email: PropTypes.string,
    }),
  }),
  setPhoneNumber: PropTypes.func,
  phoneNumber: PropTypes.string,
  phoneNumberError: PropTypes.string,
};

export default ContactDetails;
